import { render, staticRenderFns } from "./WindSpots.vue?vue&type=template&id=a449d34c&scoped=true&"
import script from "./WindSpots.vue?vue&type=script&lang=js&"
export * from "./WindSpots.vue?vue&type=script&lang=js&"
import style0 from "./WindSpots.vue?vue&type=style&index=0&id=a449d34c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a449d34c",
  null
  
)

export default component.exports